import PhoneIcon from '@assets/icons/Phone.svg'
import { ButtonHTMLAttributes, FC } from 'react'
import { cn } from '@/lib/utils'

export const PhoneButton: FC<ButtonHTMLAttributes<HTMLButtonElement>> = ({ ...rest }) => {
	return (
		<button
			{...rest}
			className={cn(
				'bg-[#F3F5F4] pr-1.5 pl-4 gap-x-3 w-full py-1.5 flex items-center rounded-[16px] transition-transform duration-150 ease-out active:scale-[0.985]',
				rest.className
			)}>
			<img
				src={PhoneIcon}
				alt=''
				aria-hidden='true'
				className='h-[24px] w-[24px] flex-none object-contain'
			/>

			<div
				className={
					'min-w-0 w-full h-10 bg-white rounded-[12px] border-solid border-[1px] border-[#DCF831] flex items-center justify-between gap-2'
				}>
				<p className={'ml-3 min-w-0 flex-none text-[14px] text-black'}>
					+7 910 <span className={'text-gray-400'}>000 00 00</span>
				</p>
				<p className={'mr-2 min-w-0 truncate text-right text-[12px] text-gray-400'}>
					Ваш номер телефона
				</p>
			</div>
		</button>
	)
}
